<template>
  <div class="gradient access lighten-2 fill-height">
    <v-container class="fill-height" align="center">
      <v-row justify="center" align="center">
        <v-col cols="10" sm="7" md="4" lg="4" xl="3">
          <v-card tile class="tile">
            <v-card-actions class="text-center justify-center py-2 white-gradient elevation-4">
              <router-link class="nolink" to="/publishing">
                <div class="logofont text-shadow pt-4">
                  <span class="primary--text">Why</span>
                  <span class="secondary--text">Buy</span>
                </div>
                <div class="raleway secondary--text pb-4">PUBLISHING</div>
              </router-link>
            </v-card-actions>
            <router-link class="nolink" exact to="/login">
              <v-container class="py-4">
                <v-row justify="center">
                  <v-col cols="12" class="text-center pl-6">
                    <v-icon color="secondary" class="tile-icon">fa-video</v-icon>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn dark large color="primary" exact to="/login">Creator Account</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </router-link>
          </v-card>
        </v-col>
        <v-col cols="10" sm="7" md="4" lg="4" xl="3">
          <v-card tile class="tile">
            <v-card-actions class="text-center justify-center py-2 white-gradient elevation-4">
              <router-link class="nolink" to="/brands">
                <div class="logofont text-shadow pt-4">
                  <span class="primary--text">Why</span>
                  <span class="secondary--text">Buy</span>
                </div>
                <div class="raleway secondary--text pb-4">CONTESTS</div>
              </router-link>
            </v-card-actions>
            <router-link class="nolink" exact to="/login-business">
              <v-container class="py-4">
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-icon color="secondary" class="tile-icon">fa-user-tie</v-icon>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn dark large color="secondary" exact to="/login-business">Business Account</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </router-link>
          </v-card>
        </v-col>
        <!--
        <v-col cols="10" sm="7" md="4" lg="4" xl="3">
          <v-card tile class="">
            <v-overlay absolute :opacity="0.9">
              <div class="text-center">
                <h1 class="grey--text text--lighten-4">Coming soon</h1>
                <v-icon x-large class="mt-4">fa-business-time</v-icon>
              </div>
            </v-overlay>
            <v-card-actions class="text-center justify-center py-2 white-gradient elevation-4">
              <a class="nolink" href="https://videoportals.whybuyglb.com">
                <div class="logofont text-shadow pt-4">
                  <span class="primary--text">Why</span>
                  <span class="secondary--text">Buy</span>
                </div>
                <div class="raleway secondary--text pb-4">VIDEO PORTALS</div>
              </a>
            </v-card-actions>
            <a class="nolink" exact href="https://videoportals.whybuyglb.com/login">
              <v-container class="py-4">
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-icon color="secondary" class="tile-icon">fa-desktop</v-icon>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn
                      dark
                      large
                      color="blue"
                      exact
                      href="https://videoportals.whybuyglb.com/login"
                    >Portal Membership</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </a>
          </v-card>
        </v-col>
        !-->

      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PublicAccess",
  data() {
    return {
      tiles: [
        {
          name: "PUBLISHING",
          to: "/publishing",
          icon: "fa-video",
          button: { text: "Creator Account", to: "/login", color: "primary" }
        },
        {
          name: "CONTESTS",
          to: "/brands",
          icon: "fa-user-tie",
          button: {
            text: "Business Account",
            to: "/login-business",
            color: "secondary"
          }
        },
        {
          name: "VIDEO PORTALS",
          to: "/video-portals",
          icon: "fa-desktop",
          button: {
            text: "Portal Membership",
            to: "/video-portals",
            color: "blue"
          }
        }
      ]
    };
  },
  created() {
    if (this.$store.getters["account/isLoggedIn"]) {
      return this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.access {
  padding-top: 100px;
  padding-bottom: 100px;
  @media only screen and (max-width: 600px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
.gradient {
  background: #fc466b;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #fc466b, #3f5efb);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #fc466b, #3f5efb);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.tile {
  -webkit-transition: 0.2s ease;
  -moz-transition: 0.2s ease;
  -o-transition: 0.2s ease;
  transition: 0.2s ease;
}

.tile:hover {
  transform: translateY(-5px);
  -webkit-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  -moz-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
}

.tile-icon {
  font-size: 7em;
}
.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 64px;
  letter-spacing: -3.3px;
}
</style>